const gapiConfig = {
  apiKey: 'AIzaSyC3p0EEIrDCWZbya1NMkKL_MeuEwvchXEk',
  clientId: '523585829004-htvk44bls5vjaq562ir5ncf0h1lp6i69.apps.googleusercontent.com',
  discoveryDocs: [
    'https://sheets.googleapis.com/$discovery/rest?version=v4',
    'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
    'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest'
  ],
  scope: 'https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/gmail.send'
}

export default gapiConfig
